import { useTimerAutomation, useTimerSyncAutomation } from '../../../hooks/useTimerMachine'

export const TimerAutomation = () => {
  useTimerAutomation()
  useTimerSyncAutomation()

  return <></>
}
